"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var Observable_1 = require("rxjs/Observable");
var TxAutoCompleteComponent = /** @class */ (function () {
    function TxAutoCompleteComponent(_changeDetector) {
        this._changeDetector = _changeDetector;
        this.txOnItemSelect = new core_1.EventEmitter();
        this.txOnInput = new core_1.EventEmitter();
        this.typedValue = '';
        this.disabled = false;
        this.cleanFieldAfterSelect = false;
        this.id = null;
        this.loadingLabel = 'Carregando...';
        this.maxResults = 50;
        this.isOnFocus = false;
        this.setEmptyEntities();
        this.setRandomId();
        this.setUpObservers();
    }
    TxAutoCompleteComponent.prototype.ngOnInit = function () {
    };
    TxAutoCompleteComponent.prototype.inputOnFocus = function () {
        this.isOnFocus = true;
        this.filterItems();
    };
    TxAutoCompleteComponent.prototype.inputOnBlur = function () {
        this.isOnFocus = false;
    };
    TxAutoCompleteComponent.prototype.performActionsOnInput = function (keyboardEvent) {
        this.setTypedValue(keyboardEvent.target.value);
        this._changeDetector.detectChanges();
        this.onInput();
    };
    TxAutoCompleteComponent.prototype.selectItem = function (item) {
        var readableItem = this.getReadableValue(item);
        var readableSelected = this.getReadableValue(this.selectedItem);
        if (readableItem !== readableSelected) {
            this.updateAutoCompleteState(readableItem, item);
            this.cleanAfterSelect();
        }
    };
    TxAutoCompleteComponent.prototype.getReadableValue = function (item) {
        return item ? (this.attributesTree ? this.inspectObjectToGetValue(item) : item) : '';
    };
    TxAutoCompleteComponent.prototype.inspectObjectToGetValue = function (object) {
        var value = object;
        for (var _i = 0, _a = this.attributesTree; _i < _a.length; _i++) {
            var field = _a[_i];
            value = value[field];
        }
        return value;
    };
    TxAutoCompleteComponent.prototype.filterItems = function () {
        if (this.performFilterInternally) {
            this.createNewItemsList();
        }
    };
    TxAutoCompleteComponent.prototype.createNewItemsList = function () {
        this.filteredItems = this.assembleFilteredItems();
    };
    TxAutoCompleteComponent.prototype.assembleFilteredItems = function () {
        var tempItems = new Array();
        for (var _i = 0, _a = this.items; _i < _a.length; _i++) {
            var item = _a[_i];
            if (this.firstStartsWithAndContainsSecondIgnoreCase(this.getReadableValue(item), this.typedValue)) {
                if (tempItems.length < this.maxResults) {
                    tempItems.push(item);
                }
                else {
                    break;
                }
            }
        }
        return tempItems;
    };
    TxAutoCompleteComponent.prototype.firstStartsWithAndContainsSecondIgnoreCase = function (first, second) {
        return first.toLowerCase().startsWith(second.charAt(0).toLowerCase())
            && first.toLowerCase().includes((second.toLowerCase()));
    };
    TxAutoCompleteComponent.prototype.getCleanLabel = function () {
        return this.label.split('')[0];
    };
    TxAutoCompleteComponent.prototype.cleanAfterSelect = function () {
        if (this.cleanFieldAfterSelect) {
            this.typedValue = '';
            this.filteredItems = new Array();
        }
    };
    TxAutoCompleteComponent.prototype.setEmptyEntities = function () {
        this.items = new Array();
        this.filteredItems = new Array();
        this.inputObserver = new Subject_1.Subject();
    };
    TxAutoCompleteComponent.prototype.setUpObservers = function () {
        var _this = this;
        this.inputObserver
            .map(function (event) { return event; })
            .debounceTime(750)
            .distinctUntilChanged()
            .flatMap(function (search) { return Observable_1.Observable.of(search).delay(500); })
            .subscribe(function (event) { return _this.performCorrectSearch(event); });
    };
    TxAutoCompleteComponent.prototype.performCorrectSearch = function (event) {
        if (this.performFilterInternally) {
            this.typedValue = event.target.value;
            this.filterItems();
        }
        else {
            this.performActionsOnInput(event);
        }
    };
    TxAutoCompleteComponent.prototype.updateAutoCompleteState = function (readable, item) {
        this.typedValue = readable;
        this.selectedItem = item;
        this.txOnItemSelect.emit(item);
        this.onInput();
    };
    TxAutoCompleteComponent.prototype.onInput = function () {
        if (this.typedValue && this.typedValue !== '') {
            this.txOnInput.emit(this.typedValue);
        }
    };
    TxAutoCompleteComponent.prototype.setTypedValue = function (value) {
        this.typedValue = value;
    };
    TxAutoCompleteComponent.prototype.setRandomId = function () {
        this.inputId = this.inputId || Math.floor((Math.random() * 1000) + 1);
        this.dropdownId = this.dropdownId || Math.floor((Math.random() * 1000) + 1);
    };
    TxAutoCompleteComponent.ctorParameters = function () { return [{ type: core_1.ChangeDetectorRef }]; };
    return TxAutoCompleteComponent;
}());
exports.TxAutoCompleteComponent = TxAutoCompleteComponent;
//# sourceMappingURL=tx-auto-complete.component.js.map


// WEBPACK FOOTER //
// tx-auto-complete.component.js